import { usePress } from "@react-aria/interactions";
import { useFocusable } from "@react-aria/focus";
import { filterDOMProps, mergeProps } from "@react-aria/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/**
 * Handles interactions for toggle elements, e.g. Checkboxes and Switches.
 */

export function useToggle(props, state, ref) {
  var _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      isRequired = props.isRequired,
      isReadOnly = props.isReadOnly,
      value = props.value,
      name = props.name,
      children = props.children,
      ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      _props$validationStat = props.validationState,
      validationState = _props$validationStat === void 0 ? 'valid' : _props$validationStat;

  var onChange = function onChange(e) {
    // since we spread props on label, onChange will end up there as well as in here.
    // so we have to stop propagation at the lowest level that we care about
    e.stopPropagation();
    state.setSelected(e.target.checked);
  };

  var hasChildren = children != null;
  var hasAriaLabel = ariaLabel != null || ariaLabelledby != null;

  if (!hasChildren && !hasAriaLabel) {
    console.warn('If you do not provide children, you must specify an aria-label for accessibility');
  } // This handles focusing the input on pointer down, which Safari does not do by default.


  var _usePress = usePress({
    isDisabled: isDisabled
  }),
      pressProps = _usePress.pressProps;

  var _useFocusable = useFocusable(props, ref),
      focusableProps = _useFocusable.focusableProps;

  var interactions = mergeProps(pressProps, focusableProps);
  var domProps = filterDOMProps(props, {
    labelable: true
  });
  return {
    inputProps: mergeProps(domProps, _babelRuntimeHelpersEsmExtends({
      'aria-invalid': validationState === 'invalid' || undefined,
      'aria-errormessage': props['aria-errormessage'],
      'aria-controls': props['aria-controls'],
      onChange: onChange,
      disabled: isDisabled,
      required: isRequired,
      readOnly: isReadOnly,
      value: value,
      name: name,
      type: 'checkbox'
    }, interactions))
  };
}